import { reducerWithInitialState } from "typescript-fsa-reducers";
import { State } from "./search.types";
import * as actions from "./search.actions";

export const initialState: Readonly<State> = {
  isSearchLoading: false,
  search: undefined,
  resultList: undefined,
  resultDetail: undefined,
  isAutoLoading: false,
  automaticConfigElements: undefined,
  error: "",
  success: "",
};

export default reducerWithInitialState(initialState)
  .case(actions.resetSearch, () => ({ ...initialState }))
  .case(actions.search, (state, { search }) => ({
    ...state,
    search,
  }))
  .case(actions.isSearchLoading, (state, { isSearchLoading }) => ({
    ...state,
    isSearchLoading,
  }))
  .case(actions.resultList, (state, { resultList }) => ({
    ...state,
    resultList,
  }))
  .case(actions.resultDetail, (state, { resultDetail }) => ({
    ...state,
    resultDetail,
  }))
  .case(actions.isAutoLoading, (state, { isAutoLoading }) => ({
    ...state,
    isAutoLoading,
  }))
  .case(actions.automaticConfigElements, (state, { automaticConfigElements }) => ({
    ...state,
    automaticConfigElements,
  }))
  .case(actions.error, (state, { error }) => ({
    ...state,
    error,
  }))
  .case(actions.success, (state, { success }) => ({
    ...state,
    success,
  }))
  .build();
